module.exports = __webpack_public_path__ + "static/media/embedCode.svg";